import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconPartner.module.css';

const IconPartner = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Capa_1"
      width="64"
      height="64"
      fill="#25d5ff"
      version="1.1"
      viewBox="0 0 548.066 548.066"
    >
      <path
        id="SVGRepo_iconCarrier"
        d="m473.239 107.971-58.889 35.972 4.284 7.269c-28.655-8.173-85.571-22.909-115.6-22.909-28.424 0-43.588 7.337-63.308 16.857-3.876 1.843-35.904 17.204-36.516 17.34l-68.816-.197-63.444 86.836 44.608 41.005c-3.767 9.826-1.557 19.42 4.42 26.314 5.732 6.672 14.267 10.371 24.412 8.426-6.807 12.92-5.937 23.324 1.632 32.027 7.317 8.426 17.599 11.533 31.416 6.332-2.448 9.295-1.571 17.619 4.896 25.16 5.841 6.799 14.532 10.41 24.888 8.568l2.448-.477c-4.399 11.512-2.4 20.727 3.808 27.879 9.438 10.996 25.738 12.193 36.38 2.789l9.656-8.357 9.316 17.469c4.576 8.678 15.626 13.002 25.5 7.82 9.744-5.242 12.75-16.666 8.092-25.568-6.731-12.586-17.815-32.986-17.815-32.986.4-9.479-2.944-13.559-7.957-18.768l7.072-4.76s19.992 38.357 27.2 51.959c4.583 8.873 15.77 12.92 25.5 7.812 10.085-5.412 12.614-16.973 8.092-25.637l-29.308-54.74 8.296-5.242 32.64 61.473c4.924 9.33 16.354 12.688 25.5 7.887 10.037-5.459 12.717-16.809 8.093-25.635l-33.933-63.859 8.637-5.168s22.439 43.111 30.531 58.48c4.577 8.676 15.627 13.002 25.5 7.82 9.452-5.033 12.988-16.32 8.093-25.643l-22.372-42.154c16.558-9.805 26.976-24.785 38.964-43.119l29.92-18.836 9.255 14.776 63.736-33.184zm-298.86 242.421c-5.664 5.037-14.334 4.168-18.904-1.285-4.814-5.379-3.835-17.211 5.44-23.061.639-.42 51.932-44.838 52.428-45.279 5.433-4.828 13.967-4.434 18.972 1.352 4.984 5.672 4.515 14.172-1.156 19.115zm36.312 31.55c-5.596 4.957-14.198 4.258-18.972-1.299-4.624-5.371-4.556-13.186.136-18.223.769-.775 41.548-36.061 42.364-36.789 5.548-4.943 14.069-4.283 18.972 1.293 5.114 5.969 4.352 14.496-1.156 19.168zm57.12 13.6-25.908 22.373c-5.542 4.924-14.13 4.318-19.04-1.359-5.046-5.746-4.264-14.438 1.224-19.115l25.908-22.57c4.95-4.236 12.866-4.684 18.564 1.014 4.515 3.616 6.052 13.735-.748 19.657m169.524-138.787c-.973.972-1.938 1.85-2.516 2.713-8.772 13.675-21.672 30.695-34.775 37.515-51.755-70.849-80.655-94.03-118.157-127.405l-87.38 40.943c-6.528 3.257-14.742.462-18.02-6.392-3.291-6.725-.523-14.898 6.256-18.156l84.728-39.712c10.744-3.944 21.896-5.787 35.7-5.787 28.825 0 96.954 18.944 125.433 26.887l41.161 70.21zM0 208.128l73.147-106.393 53.822 43.146-71.468 99.158zM129.363 308.64c-5.086-5.822-4.25-14.498 1.156-19.109l46.444-40.392c5.644-4.699 14.192-4.202 19.04 1.428 5.032 5.78 4.488 14.212-1.156 19.176l-46.512 40.256c-4.937 4.494-13.845 4.59-18.972-1.359"
      ></path>
    </svg>
  );
};

IconPartner.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconPartner.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconPartner;
